import { $get, $post } from '@/utils/axios'

const login = {
    //注册
    register(params) {
        return $post(`/ysj/api/user/web/register`, params, 'MALL')
    },
    //登录
    login(params) {
        return $post(`/ysj/api/user/web/login`, params, 'MALL')
    },
    //退出登录
    logout(params) {
        return $post(`/ysj/api/user/web/logout`, params, 'MALL')
    },
}
export default login